var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.66,
    height: 9.2,
    viewBox: "0 0 15.66 9.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-camera-fill",
    transform: "translate(-2.779 -14.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_607",
    "data-name": "Trazado 607",
    d: "M49.617,24.8a.962.962,0,0,1-.454.67.932.932,0,0,1-.947.058c-.349-.176-.686-.379-1.026-.573-.544-.31-1.085-.625-1.63-.932a.223.223,0,0,1-.136-.224q.006-1.842,0-3.683a.225.225,0,0,1,.132-.226c.818-.467,1.644-.92,2.444-1.415a1.053,1.053,0,0,1,1.641.667c0,.014.01.383.015.4v4.75a2.242,2.242,0,0,1-.04.512Z",
    transform: "translate(-31.218 -2.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_608",
    "data-name": "Trazado 608",
    d: "M8.058,24.032c-1.167,0-2.334,0-3.5,0a1.706,1.706,0,0,1-1.73-1.33,1.959,1.959,0,0,1-.045-.439q0-2.828,0-5.656a1.7,1.7,0,0,1,1.746-1.767q3.539-.011,7.078,0a1.682,1.682,0,0,1,1.744,1.735q.016,2.859,0,5.717a1.7,1.7,0,0,1-1.775,1.74c-1.172,0-2.344,0-3.516,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.c9e3a94770b72947b7a7db2e9b122bf1.svg";
export { ForwardRef as ReactComponent };